<template>
	<v-dialog
		fullscreen
		persistent
		:model-value="showSplashScreen"
		transition="slide-y-reverse-transition"
	>
		<v-sheet :class="isLandscape ? 'splash-background-landscape' : 'splash-background-portrait'">
			<v-container class="bg-transparent">
				<v-row
					class="upper-splash"
					align="center"
				>
					<v-col
						cols="12"
						class="text-center justify-center"
					>
						<div class="large-outlined">
							Kiosk
						</div>
						<div
							v-if="gettingInitialData"
							style="max-width: 400px; padding-top: 28px; position: absolute; width: 100%; left: 50%; transform: translateX(-50%)"
						>
							<v-progress-linear
								height="10"
								:color="salesCloudBaseColor"
								indeterminate
							/>
							<div
									:style="'color: ' + salesCloudBaseColor + ';'"
									style="font-size: 1.6rem; padding-top: 12px;"
							>
								{{ t('Loading data')}}
							</div>
						</div>
					</v-col>
				</v-row>
				<v-row
					class="lower-splash"
					justify="center"
					align="center"
				>
					<v-col cols="auto">
						<div v-if="hasNoKioskData" class="pb-5">
							<v-alert variant="tonal" color="warning" class="bg-white text-center" style="font-size: 1.7rem;">
								{{ t('No data received') }}
							</v-alert>
						</div>
						<div v-if="!startedSetup">
							<v-btn
								id="startSetup"
								width="400"
								height="100"
								variant="tonal"
								color="white"
								:loading="gettingInitialData"
								@click="startSetup"
								@touchend="startSetup"
							>
								<div style="font-size: 1.7rem;">
									{{ t('Start Kiosk Setup') }}
								</div>
							</v-btn>
						</div>
						<div
							v-else-if="!useCamera && !manualInput"
							class="d-flex flex-column"
						>
							<v-btn
								width="400"
								height="100"
								variant="tonal"
								color="white"
								class="mb-6"
								:loading="gettingInitialData"
								@click="openCamera"
								@touchend="openCamera"
							>
								<div style="font-size: 1.7rem;">
									{{ t('openCamera') }}
								</div>
							</v-btn>
							<v-btn
								id="startManualInput"
								width="400"
								height="100"
								variant="tonal"
								color="white"
								:loading="gettingInitialData"
								@click="startManualInput"
								@touchend="startManualInput"
							>
								<div style="font-size: 1.7rem;">
									{{ t('Enter code') }}
								</div>
							</v-btn>
						</div>
						<div v-else-if="manualInput">
							<v-text-field
								bg-color="white"
								:color="salesCloudBaseColor"
								rounded
								single-line
								variant="outlined"
								class="code-input"
								:disabled="gettingInitialData"
								v-model="handleKioskCodeInput"
							/>
							<v-btn
								id="fetchKiosk"
								width="400"
								height="100"
								variant="tonal"
								color="white"
								:loading="gettingInitialData"
								@click="fetchKiosk"
								@touchend="fetchKiosk"
							>
								<div style="font-size: 1.7rem;">
									{{ t('start') }}
								</div>
							</v-btn>
						</div>
						<div
							v-if="startedSetup"
							class="pt-10"
						>
							<v-btn
								width="400"
								height="100"
								variant="tonal"
								color="white"
								:disabled="gettingInitialData"
								@click="cancelSetup"
								@touchend="cancelSetup"
							>
								<div style="font-size: 1.7rem;">
									{{ t('Cancel Setup') }}
								</div>
							</v-btn>
						</div>
					</v-col>
				</v-row>
				<v-row
					justify="center"
					align="center"
				>
					<v-col cols="auto">
						<div
							class="text-white"
							style="font-size: 1.5rem;"
						>
							{{ t('Powered by') }} Noona
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-sheet>
	</v-dialog>
</template>

<script>
import { BarcodeScanner } from '@capacitor-community/barcode-scanner'
import { Preferences } from '@capacitor/preferences'
import { useI18n } from 'vue-i18n'
import { useStore } from '../stores/store'

export default {
	name: 'KioskSplashScreen',
	setup() {
		const store = useStore()
		const { t, te } = useI18n()

		return {
			store,
			te,
			t
		}
	},
	data() {
		return {
			startedSetup: false,
			pushedGetStarted: false,
			useCamera: false,
			manualInput: false,
			selectedUseCamera: false,
			selectedManualInput: false,
			kioskCode: null,
			selectCamera: false
		}
	},
	computed: {
		handleKioskCodeInput: {
			get() {
				return this.kioskCode
			},
			set(value) {
				if(value) {
					value = value.toLowerCase()
				}
				this.kioskCode = value
			}
		},
		showSplashScreen() {
			return this.store.showInitialSetupScreen
		},
		salesCloudBaseColor() {
			return 'rgba(34,119,221,1)'
		},
		gettingInitialData() {
			return this.store.gettingInitialData
		},
		isLandscape() {
			return this.$vuetify.display.width >= this.$vuetify.display.height
		},
		kiosk() {
			return this.store.kiosk
		},
		hasNoKioskData() {
			return this.store.hasNoKioskData
		}
	},
	methods: {
		startSetup() {
			if(this.pushedGetStarted === true) {
				return
			}
			this.pushedGetStarted = true
			setTimeout(() => {
				this.startedSetup = true
				this.pushedGetStarted = false
			}, 100)
		},
		cancelSetup() {
			if(this.pushedGetStarted === true) {
				return
			}
			this.pushedGetStarted = true
			setTimeout(() => {
				this.startedSetup = false
				this.useCamera = false
				this.manualInput = false
				this.pushedGetStarted = false
			}, 100)
		},
		startManualInput() {
			if(this.selectedManualInput === true) {
				return
			}

			this.selectedManualInput = true
			setTimeout(() => {
				this.manualInput = true
				this.selectedManualInput = false
			}, 100)
		},
		async fetchKiosk() {
			if(typeof this.kioskCode === 'undefined' || this.kioskCode === null || this.kioskCode === '') {
				return
			}

			this.store.customLogger('info', 'Manual input data fetch')

			this.store.gettingInitialData = true
			const fetchedKiosk = await this.store.getKioskData(this.kioskCode)
			if(fetchedKiosk) {
				this.store.kioskUUID = fetchedKiosk.uuid
				await this.setKioskUUID(fetchedKiosk.uuid)			
			}
		},
		async setKioskUUID(uuid) {
			if(typeof uuid !== 'undefined' && uuid !== null) {
				try {
					await Preferences.set({ key: 'sc-kiosk', value: uuid })
				} catch (e) {
					//
				}
			}
			return true
		},
		async checkPermission() {
			try {
				// check if user already granted permission
				const status = await BarcodeScanner.checkPermission({ force: false })

				if (status.granted) {
					// user granted permission
					return true;
				}

				if (status.denied) {
					// user denied permission
					return false;
				}

				// user has not denied permission
				// but the user also has not yet granted the permission
				// so request it
				const statusRequest = await BarcodeScanner.checkPermission({ force: true });

				if (statusRequest.granted) {
					// the user did grant the permission now
					return true;
				}

				// user did not grant the permission, so he must have declined the request
				return false;
			} catch (e) {
				return false
			}
		},
		openCamera() {
			if(this.selectCamera === true) {
				return
			}

			this.selectCamera = true

			setTimeout(async () => {
				this.store.customLogger('info', 'Opening camera')
				const permission = await this.checkPermission()

				if (permission) {
					this.store.scanningQRCode = true
					try {
						await BarcodeScanner.hideBackground().catch(() => console.log('hide background error'))
						const result = await BarcodeScanner.startScan().catch(() => console.log('start scan error'))

						if (result.hasContent) {
							// Stop the scan here
							await BarcodeScanner.showBackground()
							await BarcodeScanner.stopScan()
							this.store.scanningQRCode = false

							await this.setKioskUUID(result.content)
							await this.store.getKioskData(result.content)
						}
					} catch (e) {
						//
					}
				}
				this.selectCamera = false
			}, 200)
		},
	},
	watch: {
		kiosk(value) {
			if(typeof value !== 'undefined' && value !== null && typeof value.uuid !== 'undefined' && value.uuid !== null) {
				this.store.showInitialSetupScreen = false
			}
		}
	}
}
</script>

<style scoped>
.splash-background {
    background-color: rgba(34,119,221,1);
}
.splash-background-portrait {
    background-image: linear-gradient(350deg, rgba(34,119,221,1) 55%, rgba(255,255,255,1) 45%)
}
.splash-background-landscape {
    background-image: linear-gradient(357deg, rgba(34,119,221,1) 60%, rgba(255,255,255,1) 45%)
}
.upper-splash {
	height: 50vh;
}
.lower-splash {
	height: 40vh;
}

.large-outlined {
    font-size: 12rem;
    font-weight: 700;
    text-transform: uppercase;
    color: rgba(34,119,221,1);
    line-height: 100%;
}
.code-input {
	height: 100px!important;
	width: 400px!important;
	font-size: 1.5rem;
}
.code-input:deep(input) {
	font-size: 2rem;
	text-align: center;
}
</style>